__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "next";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/cache", "11.14.0", () => (() => (__webpack_require__(8711))), 1);
			register("@emotion/react", "11.14.0", () => (() => (__webpack_require__(4435))), 1);
			register("@emotion/styled", "11.14.1", () => (() => (__webpack_require__(6829))), 1);
			register("next/dynamic", "15.1.9", () => (__webpack_require__.e(152).then(() => (() => (__webpack_require__(8860))))));
			register("next/head", "15.1.9", () => (__webpack_require__.e(8).then(() => (() => (__webpack_require__(9008))))));
			register("next/image", "15.1.9", () => (Promise.all([__webpack_require__.e(675), __webpack_require__.e(460)]).then(() => (() => (__webpack_require__(5675))))));
			register("next/link", "15.1.9", () => (Promise.all([__webpack_require__.e(918), __webpack_require__.e(664)]).then(() => (() => (__webpack_require__(1664))))));
			register("next/router", "15.1.9", () => (Promise.all([__webpack_require__.e(918), __webpack_require__.e(163), __webpack_require__.e(460)]).then(() => (() => (__webpack_require__(1163))))));
			register("next/script", "15.1.9", () => (Promise.all([__webpack_require__.e(460), __webpack_require__.e(298)]).then(() => (() => (__webpack_require__(4298))))));
			register("react-dom/client", "19.2.3", () => (Promise.all([__webpack_require__.e(774), __webpack_require__.e(460)]).then(() => (() => (__webpack_require__(745))))));
			register("react-dom", "19.2.3", () => (() => (__webpack_require__(3935))), 1);
			register("react/jsx-runtime", "19.2.3", () => (__webpack_require__.e(774).then(() => (() => (__webpack_require__(5893))))));
			register("react", "19.2.3", () => (() => (__webpack_require__(7294))), 1);
			register("styled-jsx/style", "5.1.6", () => (__webpack_require__.e(543).then(() => (() => (__webpack_require__(2543))))));
			register("styled-jsx", "5.1.6", () => (__webpack_require__.e(621).then(() => (() => (__webpack_require__(2621))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};